import React, { Component } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
//import { generateText } from "@/jscript/openai.js";
import axios from "axios";
import { Link } from "react-router-dom";
import "@/css/cart.css";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prompt: "",
      text: "",
      modellist: [],
      selectedmodel: "text-davinci-003",
      history: [],
    };
  }
  render() {
    const { myusername } = this.props;

    return (
      <div
        style={{
          color: this.state.color,
          fontSize: "25px",
          padding: "30px 10px",
        }}
      >
        <form onSubmit={this.handleSubmit}>
          <label htmlFor="prompt"></label>
          {/* <select
            name="model"
            value={this.state.selectedmodel}
            onChange={(ref) => this.modelselect(ref)}
            style={{ padding: "5px" }}
          >
            {this.state.modellist.map((item, index) => {
              return (
                <option value={item.id} key={"model" + index}>
                  {item.id}
                </option>
              );
            })}
          </select> */}
          <input
            placeholder="请输入你的问题"
            ref={(input) => {
              this.prompt = input;
            }}
            style={{ margin: "8px", width: "500px" }}
          />

          <button type="submit" style={{ width: "100px" }}>
            发出
          </button>
        </form>
        {this.state.text && (
          <div style={{ whiteSpace: "pre-wrap" }}>{this.state.text}</div>
        )}
      </div>
    );
  }
  modelselect(e) {
    //  console.log(e.target.value);

    this.setState({
      selectedmodel: e.target.value,
    });
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    let prompt = this.prompt.value;

    //let str = `${process.env.REACT_APP_OPENAI_API_KEY}`;

    // const model = this.state.selectedmodel;
    //  const prompt = "Hello, OpenAI!";

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
    };

    //let posturl = "https://api.openai.com/v1/models/" + model + "/completions";
    let posturl = "https://api.openai.com/v1/chat/completions";
    let current = { role: "user", content: prompt };
    let message = this.state.history;
    message.push(current);
    let data = {
      model: "gpt-3.5-turbo",
      messages: message,
    };
    console.log(this.state.history);
    axios
      .post(posturl, data, { headers: headers })
      .then((response) => {
        let _message = response.data.choices[0].message;
        //  console.log(response.data.choices);
        //  let assis = { role: "user", content: prompt };
        message.push(_message);
        if (message.length >= 100) message.splice(0, message.length - 4);
        this.setState({
          history: message,
          text: _message.content,
        });
      })
      .catch((error) => {
        console.error(error);
      });
    // const generatedText = await generateText(prompt);

    // console.log(generatedText);
    //  setText(generatedText);
  };
  handleSubmit_gpt3 = async (event) => {
    event.preventDefault();
    let prompt = this.prompt.value;

    //let str = `${process.env.REACT_APP_OPENAI_API_KEY}`;

    const model = this.state.selectedmodel;
    //  const prompt = "Hello, OpenAI!";
    console.log(prompt);
    console.log(model);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
    };

    let posturl = "https://api.openai.com/v1/models/" + model + "/completions";
    posturl = "https://api.openai.com/v1/completions";

    let data = {
      model: model,
      prompt: prompt,
      temperature: 0.5,
      max_tokens: 2000,
      top_p: 0.5,
      frequency_penalty: 0,
      presence_penalty: 0,
    };
    axios
      .post(posturl, data, { headers: headers })
      .then((response) => {
        let result = response.data.choices[0].text;
        console.log(response.data.choices[0].text);
        this.setState({
          text: result,
        });
      })
      .catch((error) => {
        console.error(error);
      });
    // const generatedText = await generateText(prompt);

    // console.log(generatedText);
    //  setText(generatedText);
  };
  listmodel() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
    };

    axios
      .get(
        "https://api.openai.com/v1/models",

        { headers: headers }
      )
      .then((response) => {
        const list = response.data.data;
        list.forEach((element) => console.log(element.id));
        this.setState({
          modellist: list,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
  componentDidMount() {
    document.title = "Open Ai";
    // this.listmodel();
  }

  componentWillUnmount() {
    //   $("#bottomer").css("display", "block");
  }

  componentWillUpdate() {}
  componentDidUpdate() {}
}

export default connect(null, null)(Index);
